import { TRANSACTIONS_HEADERS } from "../types/transactionsHeadersTypes";

export const setTransactionsHeaders = (data: any) => {
  return {
    type: TRANSACTIONS_HEADERS.TRANSACTIONS_HEADERS_SET_SELECTED,
    payload: { ...data },
  };
};

export const cleTrtransactionsHeaders = () => {
  return {
    type: TRANSACTIONS_HEADERS.TRANSACTIONS_HEADERS_CLEAR_SELECTED,
  };
};
